import { render } from "./StepWells.vue?vue&type=template&id=7b176d64"
import script from "./StepWells.vue?vue&type=script&lang=js"
export * from "./StepWells.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__